module.exports = __webpack_public_path__ + "static/media/StudentInterviewTimeData.cbe7c842.xlsx";